import useOnclickOutside from "react-cool-onclickoutside";
import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import usePlacesAutocomplete, {
  getDetails,
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

export const PlacesAutocomplete = ({
  setAllDetails,
  setActiveMarker,
  allDetails,
}) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });
  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleInput = (e) => {
    // Update the keyword of the input element
    setValue(e.target.value);
  };

  const notifAdd = () => {
    Store.addNotification({
      title: "Succesful!",
      message: "Location succesfully added!",
      type: "success",
      insert: "bottom-right",
      container: "bottom-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 1000,
        onScreen: true,
      },
    });
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false);
      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: description })
        .then((results) => {
          const id = results[0].place_id;
          const { lat, lng } = getLatLng(results[0]);
          const parameter = {
            // Use the "place_id" of suggestion from the dropdown (object), here just taking first suggestion for brevity
            placeId: results[0].place_id,
            // Specify the return data that you want (optional)
            fields: [
              "url",
              "type",
              "photo",
              "formatted_address",
              "name",
              "icon",
              "rating",
              "formatted_phone_number",
              "opening_hours",
              "website",
            ],
          };

          getDetails(parameter).then((details) => {
            const exist = allDetails.findIndex((elt) => elt.id === id) !== -1;
            !exist &&
              setAllDetails((prev) => [
                ...prev,
                { id, details, geocode: { lat, lng } },
              ]);
          });
          setActiveMarker(id);
          notifAdd();
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  return (
    <div ref={ref} className="w-full flex justify-center flex-col items-center">
      <div className="relative w-[50%] mobile-s-w">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg
            aria-hidden="true"
            className="w-5 h-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            ></path>
          </svg>
        </div>
        <input
          value={value}
          onChange={handleInput}
          disabled={!ready}
          className="block w-full p-4 pl-10 text-sm border rounded-lg bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-white-500 focus:border-blue-500"
          placeholder="Where are you going?"
          required
        />
      </div>

      {/* We can use the "status" to decide whether we should display the dropdown or not */}
      {status === "OK" && (
        <ul className="bg-gray-600 rounded-lg p-2 w-[50%] text-white overflow-auto cursor-pointer">
          {renderSuggestions().map((sug) => {
            return (
              <li
                key={sug.key}
                className="bg-gray-700 mb-1 rounded-lg p-2 pl-3 hover:bg-gray-800"
              >
                {sug}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
